import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { errMsg } from "../lib/api";
import { useToast } from "../lib/toast";
import { Button, Field } from "../components/ui";
import { AuthAside } from "../components/AuthAside";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  const handleSignup = async (e) => {
    e?.preventDefault();
    if (!name || !email || !password) {
      toast.error("Missing details", "All fields are required to create an account.");
      return;
    }
    try {
      setLoading(true);
      await api.post("/api/auth/signup", { name, email, password });
      toast.success("Account created", "You can sign in now.");
      navigate("/");
    } catch (err) {
      toast.error("Sign up failed", errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-white">
      <AuthAside />

      <div className="flex flex-1 items-center justify-center px-6 py-12">
        <div className="w-full max-w-[380px] animate-slide-up">
          <div className="mb-8 lg:hidden">
            <img src="/mmc_logo.png" alt="MMC Convert" className="h-11" />
          </div>

          <h1 className="text-[26px] font-semibold tracking-tight text-ink-900">
            Create your account
          </h1>
          <p className="mt-1.5 text-[14px] text-ink-500">
            Get started with Excel to Naqood.
          </p>

          <form onSubmit={handleSignup} className="mt-8 space-y-4">
            <Field label="Full name">
              <input
                type="text"
                autoComplete="name"
                placeholder="Jane Doe"
                className="field-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Field>

            <Field label="Email address">
              <input
                type="email"
                autoComplete="email"
                placeholder="you@company.com"
                className="field-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Field>

            <Field label="Password" hint="Use at least 8 characters.">
              <input
                type="password"
                autoComplete="new-password"
                placeholder="••••••••"
                className="field-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Field>

            <Button
              type="submit"
              size="lg"
              loading={loading}
              className="w-full !mt-6"
            >
              {loading ? "Creating account…" : "Create account"}
            </Button>
          </form>

          <p className="mt-6 text-center text-[13.5px] text-ink-500">
            Already have an account?{" "}
            <Link
              to="/"
              className="font-semibold text-brand-600 hover:text-brand-700"
            >
              Sign in
            </Link>
          </p>

          <p className="mt-10 text-center text-[11.5px] text-ink-400">
            © 2026 MMC Convert
          </p>
        </div>
      </div>
    </div>
  );
}
